import {Vector2} from 'three'

import type {MonaCanvasOpeningAnimation} from '../../MonaCanvas'
import {OpeningAnimation} from '../../MonaCanvas/opening-animation'

const START_X = -1.5
const END_X = 0.5
const VERTICAL_OFFSET = 0.0

const getSineY = (x: number) => Math.sin(x * 2 * Math.PI + Math.PI) * 1.0

class MonaDividerOpeningAnimation extends OpeningAnimation {
  readonly restingYawRadians = Math.PI / 6
  restingFacingProgress = 0
  readonly pointerPosition = new Vector2(START_X, VERTICAL_OFFSET + getSineY(START_X))

  get isReadyForHandoff() {
    return this.timeline.totalProgress() > 0.7
  }

  constructor() {
    super()
    const position = {x: START_X}
    this.timeline.to(position, {
      x: END_X,
      duration: 6,
      ease: 'expo.out',
      onUpdate: () => {
        this.pointerPosition.x = position.x
        this.pointerPosition.y = VERTICAL_OFFSET + getSineY(this.pointerPosition.x)
      },
    })
    this.timeline.to(this, {restingFacingProgress: 1, duration: 1, ease: 'power1.inOut'}, 2)
  }
}

export function createMonaDividerOpeningAnimation(): MonaCanvasOpeningAnimation {
  return new MonaDividerOpeningAnimation()
}
